import React from "react";
import Container from "../Components/Container";
import TitleSection from "../Components/TitleSection";
import EventSummary from "../Components/EventSummary";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import { ArrowLeft, CalendarX } from "@phosphor-icons/react";
import { findCancelReasonByResponsible } from "constants/cancelReasons";
import useCancelVideoCall from "hooks/api/appointments/useCancelVideoCall";
import { LoadingButton } from "@mui/lab";
import { useGlobalToast } from "components/GlobalToastProvider";
import { useParams } from "react-router-dom";
import { STEPS } from "../utils";
import { useRescheduling } from "../ReschedulingProvider";

const cancelReasons = [
  ...findCancelReasonByResponsible("client").cancelReasons,
  "Prefer not to say",
];

export default function CancelAppointment() {
  const { setStep, onBack, callInfo } = useRescheduling();
  const { showToast } = useGlobalToast();
  const { id: videoId } = useParams();
  const [cancelReason, setCancelReason] = React.useState("");
  const [screenWidth] = React.useState(window.innerWidth);
  const { cancelVideoCall, isCancelVideoCallLoading } = useCancelVideoCall();

  return (
    <Container showGoHome>
      <TitleSection
        title="Cancel your appointment?"
        subtitle="Are you sure you’d like to cancel your upcoming appointment?"
      />
      <EventSummary eventDate={callInfo?.scheduled_date} />
      <Stack gap={7}>
        <FormControl>
          <FormLabel>Provide a reason for canceling</FormLabel>
          <RadioGroup
            aria-label="responsibleForCancellation"
            name="responsibleForCancellation"
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
          >
            {cancelReasons.map((reason, i) => {
              return (
                <FormControlLabel
                  value={reason}
                  control={<Radio color="primary" size={screenWidth < 834 ? "large" : "small"} />}
                  label={reason}
                  key={i}
                />
              );
            })}
          </RadioGroup>
        </FormControl>
        <Stack gap={3}>
          <LoadingButton
            disabled={!cancelReason}
            loading={isCancelVideoCallLoading}
            size="large"
            color="error"
            startIcon={<CalendarX />}
            onClick={() =>
              cancelVideoCall(
                {
                  id: videoId,
                  message: cancelReason,
                  responsibleForCancellation: "client",
                  //   clinicianUserId: videoChatInfo.clinician_user_id,
                  cancelAllInstances: false,
                },
                {
                  onSuccess: () => {
                    showToast({ message: "Event cancelled successfully" });
                    setStep(STEPS.cancellationConfirmation);
                  },
                }
              )
            }
          >
            Cancel Appointment
          </LoadingButton>
          <Button
            size="large"
            variant="text"
            color="secondary"
            onClick={onBack}
            startIcon={<ArrowLeft />}
          >
            Back
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
}
